<mat-progress-bar mode="query" *ngIf="loadingService.isLoading()"></mat-progress-bar>

<router-outlet />
